import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Container from "components/shared/Container";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import cx from "classnames";
import { Button } from "components/components/atoms";

const CopyText = styled.div`
  line-height: 1.063rem;
`;

const DisclaimerText = (component) => {
  const { text } = component.fields;
  const textAlignment =
    getFieldValue(component.fields, "textAlignment") || "center";
  const ctaText = getFieldValue(component.fields, "ctaText");
  const ctaLink = getFieldValue(component.fields, "ctaLink");

  return (
    <Container className="py-4">
      <CopyText
        className={cx(
          "text-mattamy-blue font-graphie text-sm tracking-normal ",
          {
            "text-center": textAlignment && textAlignment !== "left",
            "text-left": !textAlignment || textAlignment === "left",
          }
        )}
      >
        <RichText tag="span" className="richtext" field={text} />
      </CopyText>
      {ctaLink && ctaText && (
        <div className="mt-4 md:mt-6 text-center">
          <Button
            variant={"outlined"}
            color={"mattamy-blue"}
            textColor={"mattamy-blue"}
            href={ctaLink.href}
            target={ctaLink.target}
            linkWrapperDescription={ctaText}
          >
            {ctaText}
          </Button>
        </div>
      )}
    </Container>
  );
};
export default DisclaimerText;
